import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import ComparisonRange from '../../config/comparisonRange';
import { useAccountPreferences } from '../../contexts/accountPreferencesContext';
import { formatNumber } from '../../utils/formatters/formatNumber';
import { DateComparisonRanges } from '../GlobalFilterBar/types';
import { container, getArrowStyles, getChipStyles, label as labelSx } from './styles';
import { ChipColor } from '../../lib/styles/helpers';

interface DeltaChipIndicatorProps {
  value?: string | number;
  isImprovement: boolean;
  dataTestId: string;
  comparisonRange?: ComparisonRange | DateComparisonRanges | null;
}

export default function DeltaChipIndicator(props: DeltaChipIndicatorProps) {
  const { comparisonRange, value, isImprovement, dataTestId } = props;
  const { t } = useTranslation();
  const { preferences } = useAccountPreferences();

  const isNoChange = Number(value) === 0;

  const upArrow = '↑';
  const downArrow = '↓';
  const arrow = Number(value) > 0 ? upArrow : downArrow;

  const label = comparisonRange ? t(`deltaIndicatorChip.${comparisonRange}`) : t('deltaIndicatorChip.none');

  let chipColor: ChipColor = isImprovement ? 'success' : 'error';
  if (isNoChange) {
    chipColor = 'default';
  }

  return (
    <Box data-testid={dataTestId} sx={container}>
      {comparisonRange ? (
        <Chip
          size='small'
          color={chipColor}
          sx={getChipStyles(isImprovement, isNoChange)}
          label={
            <>
              {!isNoChange && <span style={getArrowStyles(isImprovement)}>{arrow}</span>}
              <span>{`${formatNumber(Number(value) * 100, preferences ?? undefined, undefined, 1)}%`}</span>
            </>
          }
        />
      ) : null}
      <Typography color='secondary' data-testid={`${dataTestId}-label`} sx={labelSx}>
        {label}
      </Typography>
    </Box>
  );
}

DeltaChipIndicator.defaultProps = {
  value: undefined,
  comparisonRange: undefined,
};
